import loadable from '@loadable/component';

export const OrgDashboardEditInternshipPageLoadable = loadable(
  () => import('./OrgDashboardEditInternshipPage'),
  { resolveComponent: (module) => module.OrgDashboardEditInternshipPage },
);
